export const getTimezone = state => state.preferences.timezone;
export const getUserPreferences = state => state.preferences;
export const getUserLanguages = state => state.preferences.languages;
export const getUser = state => state.authUser;
export const getAreCredentialsInvalid = state => state.areCredentialsInvalid;
export const getIsAuthenticated = state => state.isAuthenticated;
export const getIsSessionLoading = state => state.isLoading;
export const getHasAttemptedAuth = state => state.hasAttemptedAuth;
export const getHasTimeout = state => state.hasTimeout;
